import { SITE_NAME, absoluteUrl } from './site'

const PUBLISHER_LOGO_PATH = '/og/paszport-dolnego-slaska-og.webp'

export type NewsArticleJsonLdInput = {
  headline: string
  description: string
  pathname: string
  /** ISO date (YYYY-MM-DD) */
  publishedAt: string
  modifiedAt?: string
  imageUrl?: string | null
  imageUrls?: readonly string[]
  inLanguage: string
}

function toWarsawIsoDate(isoDate: string): string {
  if (isoDate.includes('T')) return isoDate
  return `${isoDate}T08:00:00+02:00`
}

export function buildNewsArticleJsonLd(input: NewsArticleJsonLdInput) {
  const url = absoluteUrl(input.pathname)
  const modifiedAt = input.modifiedAt ?? input.publishedAt

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: input.headline,
    description: input.description,
    url,
    datePublished: toWarsawIsoDate(input.publishedAt),
    dateModified: toWarsawIsoDate(modifiedAt),
    inLanguage: input.inLanguage,
    ...(() => {
      const images = (
        input.imageUrls?.length
          ? [...input.imageUrls]
          : input.imageUrl
            ? [input.imageUrl]
            : []
      ).filter(Boolean)
      return images.length ? { image: images } : {}
    })(),
    author: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: absoluteUrl('/'),
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: absoluteUrl('/'),
      logo: {
        '@type': 'ImageObject',
        url: absoluteUrl(PUBLISHER_LOGO_PATH),
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: absoluteUrl('/'),
    },
  }
}

export function newsCoverAbsoluteUrl(coverPath: string): string {
  if (/^https?:\/\//i.test(coverPath)) return coverPath
  const path = coverPath.startsWith('/') ? coverPath : `/${coverPath}`
  return absoluteUrl(path)
}
